import { ModalWithTitle, Theme } from "@outschool/backpack";
import { faBellConcierge } from "@outschool/icons";
import { useTranslation } from "@outschool/localization";
import { useTrackEvent } from "@outschool/ui-analytics";
import { useNavigation } from "@outschool/ui-utils";
import React from "react";
import { useLocation } from "react-router-dom";

import { ChatProvider } from "./chatProvider";
import { ChatWindow } from "./ChatWindow";
import { CHAT_FLOW_CONFIGS } from "./consts";

type ConciergeChatModalProps = {
  isOpen: boolean;
  setIsModalOpen: (_: boolean) => void;
};

export default function ConciergeChatModal({
  isOpen,
  setIsModalOpen
}: ConciergeChatModalProps) {
  const { t } = useTranslation("client\\components\\chat");
  const trackEvent = useTrackEvent();
  const navigate = useNavigation();
  const location = useLocation();
  const closeModal = () => {
    setIsModalOpen(false);
    trackEvent("concierge_modal_closed");
    const params = new URLSearchParams(location.search);
    params.delete("openConcierge");
    navigate(location.pathname + "?" + params.toString());
  };

  return (
    <ModalWithTitle
      headerTitle={t("Concierge")}
      headerIcon={faBellConcierge}
      closeButtonArialLabel={t("Close chat")}
      open={isOpen}
      onClose={closeModal}
      modalContentProps={{
        sx: (theme: Theme) => ({
          // eslint-disable-next-line i18next/no-literal-string
          [theme.breakpoints.up("md")]: {
            maxWidth: "50%"
          },
          // eslint-disable-next-line i18next/no-literal-string
          [theme.breakpoints.down("md")]: {
            height: "100dvh",
            // eslint-disable-next-line i18next/no-literal-string
            margin: "0 auto",
            // eslint-disable-next-line i18next/no-literal-string
            maxHeight: "100dvh"
          }
        })
      }}
      sx={{
        zIndex: 2147483647 // must be higher than Intercom chat z-index (2147483000)
      }}
    >
      <ChatProvider
        initState={CHAT_FLOW_CONFIGS.concierge.initState}
        setIsModalOpen={setIsModalOpen}
      >
        <ChatWindow />
      </ChatProvider>
    </ModalWithTitle>
  );
}
